import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

// actions
import {
  _getIssueList,
  CLEAR_ISSUE_OLD_FILTERS_ACTION
} from "../../actions/issues.action";
import { PROJECT_AWARDED_BY } from "../../constant";
import { getLocalstorage } from "../../helper";
import {
  getDashboardNotifications,
  getDashboardNotificationsAllViewed,
  getNotificationUpdates
} from "../../actions/dashboard.action";

export function IssueListHoc(WrapperComponent) {
  class IssueListHocInner extends Component {
    componentDidMount() {
      try {
        const {
          location: { state, isDashBoard, summaryDataBy },
          _getIssueList,
          getDashboardNotifications,
          getNotificationUpdates,
          issueListReducer: { selectedFilters }
        } = this.props;
        const userSponsoredScheme = getLocalstorage("userSponsoredScheme");

        const groupCategory =
          (isDashBoard && summaryDataBy) || userSponsoredScheme
            ? PROJECT_AWARDED_BY.STATE
            : PROJECT_AWARDED_BY.CENTRAL;

        let categoryForNotification = isDashBoard
          ? isDashBoard && summaryDataBy
          : userSponsoredScheme;

        let category = categoryForNotification
          ? PROJECT_AWARDED_BY.STATE
          : PROJECT_AWARDED_BY.CENTRAL;
        let params = {};
        if (isDashBoard) {
          params = { ...state };
        } else {
          params["projectGroupBy"] = [
            { key: "projectGroupBy", displayName: "Project", checked: true }
          ];
        }
        //console.log("params-------------------------", params);
        // call api
        getDashboardNotificationsAllViewed(undefined, category).then(resp => {
          // if (resp && resp.status) getDashboardNotifications();
          if (resp && resp.status) getNotificationUpdates();
        });
        const isCentral = "CENTRAL";
        const user = getLocalstorage("user");
        if (
          (user.groupCategory === "STATE_PMG" && !isDashBoard) ||
          (user.groupCategory === "STATE" && !isDashBoard) ||
          (user.groupCategory === "DISTRICT" && !isDashBoard) ||
          (user.groupCategory === "STATE_DEPARTMENT" && !isDashBoard)
        ) {
          _getIssueList(
            { ...selectedFilters, groupCategory: isCentral, ...params },
            true
          );
        } else {
          _getIssueList({ ...selectedFilters, groupCategory, ...params }, true);
        }
      } catch (error) {
        console.error(error);
      }
    }

    componentWillUnmount() {
      const {
        location: { isDashBoard, summaryDataBy },
        CLEAR_ISSUE_OLD_FILTERS_ACTION
      } = this.props;
      const userSponsoredScheme = getLocalstorage("userSponsoredScheme");

      const groupCategory =
        (isDashBoard && summaryDataBy) || userSponsoredScheme
          ? PROJECT_AWARDED_BY.STATE
          : PROJECT_AWARDED_BY.CENTRAL;
      CLEAR_ISSUE_OLD_FILTERS_ACTION(groupCategory);
    }

    render() {
      const { props } = this;

      return <WrapperComponent {...props} />;
    }
  }

  function mapStateToProps(state) {
    const { issueListReducer } = state;
    return {
      issueListReducer
    };
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        _getIssueList,
        CLEAR_ISSUE_OLD_FILTERS_ACTION,
        getDashboardNotifications,
        getNotificationUpdates
      },
      dispatch
    );
  }

  return withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(IssueListHocInner)
  );
}
